export default "__VITE_ASSET__DoZxKt0l__"